export default __webpack_public_path__ + "static/media/img11.c8d58ebd.png";